import { render, staticRenderFns } from "./CreateContract.vue?vue&type=template&id=248f5c1e&"
import script from "./CreateContract.vue?vue&type=script&lang=js&"
export * from "./CreateContract.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports